"use client"

import clsx from "clsx"
import { type ReactNode, useState } from "react"
import { AdSlot } from "@/components/AdSlot/AdSlot.component"
import { useHeader } from "@/contexts/header/header.context"

type StickyBannerProps = {
  readonly children: ReactNode
  readonly stickyBannerId?: "sticky" | "sticky_halfpage"
  readonly className?: string
}

export function StickyBanner({
  children,
  stickyBannerId = "sticky",
  className,
}: StickyBannerProps) {
  const [isStickyEmpty, setIsStickyEmpty] = useState<boolean>(true)
  const { isVisible } = useHeader()

  return (
    <div
      className={clsx(
        "my-2 lg:my-4",
        isStickyEmpty ? "container px-0" : "banner-container",
      )}
    >
      {/* Main layout */}
      <div className="container 2xl:mx-0">{children}</div>
      <div
        className={clsx(
          "sticky-banner sticky top-2.5 hidden self-start transition-transform duration-300 ease-in-out print:hidden",
          className,
          !isStickyEmpty && "2xl:block",
          isVisible ? "translate-y-10" : "translate-y-0",
        )}
      >
        <AdSlot
          className={clsx(
            "bg-transparent! lg:h-[600px]",
            stickyBannerId === "sticky_halfpage" && "lg:w-[300px]",
            stickyBannerId === "sticky" && "lg:w-[160px]",
          )}
          domId={stickyBannerId}
          onBeforeShow={(isEmpty) => setIsStickyEmpty(isEmpty)}
        />
      </div>
    </div>
  )
}
